/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './__root'
import { Route as PendingRouteImport } from './pending'
import { Route as LoginRouteImport } from './login'
import { Route as AppRouteImport } from './_app'
import { Route as AppIndexRouteImport } from './_app/index'
import { Route as JoinTokenRouteImport } from './join.$token'
import { Route as AppSplitsRouteImport } from './_app/splits'
import { Route as AppSetupRouteImport } from './_app/setup'
import { Route as AppSettingsRouteImport } from './_app/settings'
import { Route as AppRosterRouteImport } from './_app/roster'

const PendingRoute = PendingRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSplitsRoute = AppSplitsRouteImport.update({
  id: '/splits',
  path: '/splits',
  getParentRoute: () => AppRoute,
} as any)
const AppSetupRoute = AppSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppRosterRoute = AppRosterRouteImport.update({
  id: '/roster',
  path: '/roster',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/pending': typeof PendingRoute
  '/roster': typeof AppRosterRoute
  '/settings': typeof AppSettingsRoute
  '/setup': typeof AppSetupRoute
  '/splits': typeof AppSplitsRoute
  '/join/$token': typeof JoinTokenRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/pending': typeof PendingRoute
  '/roster': typeof AppRosterRoute
  '/settings': typeof AppSettingsRoute
  '/setup': typeof AppSetupRoute
  '/splits': typeof AppSplitsRoute
  '/join/$token': typeof JoinTokenRoute
  '/': typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/pending': typeof PendingRoute
  '/_app/roster': typeof AppRosterRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/setup': typeof AppSetupRoute
  '/_app/splits': typeof AppSplitsRoute
  '/join/$token': typeof JoinTokenRoute
  '/_app/': typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/pending'
    | '/roster'
    | '/settings'
    | '/setup'
    | '/splits'
    | '/join/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/pending'
    | '/roster'
    | '/settings'
    | '/setup'
    | '/splits'
    | '/join/$token'
    | '/'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/pending'
    | '/_app/roster'
    | '/_app/settings'
    | '/_app/setup'
    | '/_app/splits'
    | '/join/$token'
    | '/_app/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  PendingRoute: typeof PendingRoute
  JoinTokenRoute: typeof JoinTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/pending': {
      id: '/pending'
      path: '/pending'
      fullPath: '/pending'
      preLoaderRoute: typeof PendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/splits': {
      id: '/_app/splits'
      path: '/splits'
      fullPath: '/splits'
      preLoaderRoute: typeof AppSplitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/setup': {
      id: '/_app/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AppSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roster': {
      id: '/_app/roster'
      path: '/roster'
      fullPath: '/roster'
      preLoaderRoute: typeof AppRosterRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppRosterRoute: typeof AppRosterRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSetupRoute: typeof AppSetupRoute
  AppSplitsRoute: typeof AppSplitsRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppRosterRoute: AppRosterRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSetupRoute: AppSetupRoute,
  AppSplitsRoute: AppSplitsRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  PendingRoute: PendingRoute,
  JoinTokenRoute: JoinTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
